import { fetchData } from '@umu/umu-fetch';

import Api from '../../../path';
import { IInput } from './models/input';
import IOutput from './models/output';
import { getConfig, getCourseRankSharePic } from '../../api';
import { IOutputBase } from '../../api/base';
import { getExamRankingSharePicFull } from '../../element/quiz/getExamRankingSharePic/request';
import { ShareType } from '@umu/umu-types';

interface IOptions {
	poll_timeout_ms?: number;
	poll_max_times?: number;
	use_puppeteer?: boolean;
}

export const getShare = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.SHARE_IMG, data);
};

export const napiGetShare = (data: IInput): Promise<IOutputBase<{ id: number }>> => {
	return fetchData(Api.NAPI_HTML_TO_PIC, data);
}

export const napiGetShareStatus = (data: { id: string | number }): Promise<IOutputBase<{ source_url: string, pic_url: string, status: number }>> => {
	return fetchData(Api.NAPI_HTML_TO_PIC_STATUS, data);
}

function sleep(ms: number) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export const getShareV2 = async (data: IInput, options?: IOptions): Promise<IOutput> => {
        options = options || {};
	const pollMaxTimes = options && options.poll_max_times;
	const pollTimeoutMs = options && options.poll_timeout_ms || 1500;

	let requestFn: any = getShare;
	if (data.obj_type === ShareType.OLD_COURSE_RANK_SHARE) {
		requestFn = getCourseRankSharePic;
	} else if (data.obj_type === ShareType.OLD_EXAM_RANK_SHARE) {
		requestFn = getExamRankingSharePicFull;
	}

    if (typeof options.use_puppeteer === 'undefined') {
        const config = await getConfig({ key: `screenshot_${data.obj_type}_version`});
        if (config.data && config.data === '1') {
            options.use_puppeteer = false;
        } else {
            options.use_puppeteer = true;
        }
    }

	// 默认走新截图，只有配置为1的时候走老截图
	if (!options.use_puppeteer) {
		const shareResult = await requestFn(data);
		data.task_id = shareResult.data.task_id;

		let pollCount = 0;
		while (true) {
			pollCount++;
			if (pollMaxTimes && pollCount > pollMaxTimes) {
				throw new Error('poll max times');
			}
			const pollResult = await requestFn(data);
			// 2: 任务成功
			if (pollResult.data.status === 2) {
				return pollResult;
			}
			await sleep(pollTimeoutMs);
		}
	} else {
		const shareResult = await napiGetShare(data);

		let pollCount = 0;
		while (true) {
			pollCount++;
			if (pollMaxTimes && pollCount > pollMaxTimes) {
				throw new Error('poll max times');
			}
			const pollResult = await napiGetShareStatus({ id: shareResult.data.id })
			// 3: 任务失败，4: 任务成功
			if (pollResult.data.status === 4) {
				return pollResult;
			} else if (pollResult.data.status === 3) {
				throw pollResult;
			}
			await sleep(pollTimeoutMs);
		}
	}
}

export type IGetShareInput = IInput;
